export default __webpack_public_path__ + "locales/vi/DataReassignmentDialog.json?hash=31fef772ea34cfdff0b816a8655e63cd";